export default "__VITE_ASSET__Det5yrpz__";